module.exports = __webpack_public_path__ + "static/img/44.564f5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/44.png
// module id = P5pX
// module chunks = 0